(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["club_usps_bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SECTION_SELECTOR = '[data-club-usps-bar]';
    const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';
    const instances = new WeakMap();

    const destroyMarquee = (section) => {
      const instance = instances.get(section);
      if (!instance) return;

      window.removeEventListener('resize', instance.onResize);
      if (instance.motionQuery.removeEventListener) {
        instance.motionQuery.removeEventListener('change', instance.onMotionChange);
      } else if (instance.motionQuery.removeListener) {
        instance.motionQuery.removeListener(instance.onMotionChange);
      }
      section.classList.remove('club-usps-bar--is-ready');
      instances.delete(section);
    };

    const buildMarquee = (section, motionQuery) => {
      const viewport = section.querySelector('[data-club-usps-viewport]');
      const track = section.querySelector('[data-club-usps-track]');
      const source = section.querySelector('[data-club-usps-source]');
      if (!viewport || !track || !source) return;

      const clones = track.querySelectorAll('[data-club-usps-clone="true"]');
      for (const clone of clones) clone.remove();

      if (motionQuery.matches) {
        section.style.setProperty('--club-usps-loop-width', '0px');
        section.classList.remove('club-usps-bar--is-ready');
        return;
      }

      const sourceWidth = Math.ceil(source.getBoundingClientRect().width);
      if (!sourceWidth) return;

      const seamGap = parseFloat(window.getComputedStyle(track).columnGap || '0') || 0;
      const loopWidth = sourceWidth + seamGap;
      section.style.setProperty('--club-usps-loop-width', `${loopWidth}px`);

      let totalWidth = sourceWidth;
      const minimumWidth = loopWidth + viewport.clientWidth;
      while (totalWidth < minimumWidth) {
        const clone = source.cloneNode(true);
        clone.dataset.clubUspsClone = 'true';
        clone.setAttribute('aria-hidden', 'true');
        track.append(clone);
        totalWidth += sourceWidth + seamGap;
      }

      section.classList.add('club-usps-bar--is-ready');
    };

    const initMarquee = (section) => {
      destroyMarquee(section);

      const motionQuery = window.matchMedia(REDUCED_MOTION_QUERY);
      let resizeFrame = null;
      const queueBuild = () => {
        if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
        resizeFrame = window.requestAnimationFrame(() => buildMarquee(section, motionQuery));
      };

      const onResize = () => queueBuild();
      const onMotionChange = () => queueBuild();

      instances.set(section, { onResize, onMotionChange, motionQuery });
      window.addEventListener('resize', onResize);
      if (motionQuery.addEventListener) {
        motionQuery.addEventListener('change', onMotionChange);
      } else if (motionQuery.addListener) {
        motionQuery.addListener(onMotionChange);
      }
      queueBuild();
    };

    const bindToggle = (section) => {
      const toggle = section.querySelector('[data-club-usps-toggle]');
      if (!toggle || toggle.dataset.clubUspsBound) return;
      toggle.dataset.clubUspsBound = 'true';

      toggle.addEventListener('click', () => {
        const paused = section.classList.toggle('club-usps-bar--paused');
        toggle.setAttribute('aria-pressed', String(paused));
        toggle.setAttribute(
          'aria-label',
          paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel
        );
      });
    };

    const initAllMarquees = (container = document) => {
      const sections = container.matches?.(SECTION_SELECTOR)
        ? [container]
        : container.querySelectorAll(SECTION_SELECTOR);
      for (const section of sections) {
        initMarquee(section);
        bindToggle(section);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAllMarquees());
    } else {
      initAllMarquees();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initAllMarquees(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      if (!event.target.matches?.(SECTION_SELECTOR)) return;
      destroyMarquee(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
